import { render, staticRenderFns } from "./instorage.vue?vue&type=template&id=61d9301c&"
import script from "./instorage.vue?vue&type=script&lang=js&"
export * from "./instorage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports